var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.globalConfig.brandName && !_vm.disableBranding)?_c('div',{staticClass:"px-0 py-3 flex justify-center"}):_c('div',{staticClass:"p-3"})
}
var staticRenderFns = []

export { render, staticRenderFns }